import { config } from "../utils/config";
import { omniAxios } from "../utils/axios";
import { CookieKeys, Cookies } from "../utils/cookieKey";

//获取用户信息
export function restUCompanyGetCompanyInfo() {
  return omniAxios({
    url: config.restUCompanyGetCompanyInfoPath,
    method: "get",
    params: {},
    isTwoPointZeroInterfaceApi: true,
  });
}
// 获取是否显示定制版会员中心入口
export function commonCusApiHomepageIdTypeGw({ id }) {
  return omniAxios({
    url: config.commonCusApiHomepageIdTypeGwPath,
    method: "get",
    params: {
      id,
    },
  });
}
// 实时标讯
export function restServiceHomepageRealTimeTender() {
  return omniAxios({
    url: config.restServiceHomepageRealTimeTenderPath,
    method: "get",
    params: {},
  });
}
//实时标讯行业导航
export function restCommonHomepageSpecialZone() {
  return omniAxios({
    url: config.restCommonHomepageSpecialZonePath,
    method: "get",
    params: {},
  });
}
// 获取底部横幅信息 底部信息
export function restCommonHomepageBottomBanner() {
  return omniAxios({
    url: config.restCommonHomepageBottomBannerPath,
    method: "get",
    params: {},
  });
}
// 千里马分站
export function restCommonHomepageSubWebsite() {
  return omniAxios({
    url: config.restCommonHomepageSubWebsitePath,
    method: "get",
    params: {},
  });
}
// 行业导航
export function restCommonHomepageIndustryNavigation() {
  return omniAxios({
    url: config.restCommonHomepageIndustryNavigationPath,
    method: "get",
    params: {},
  });
}
// 预约回电
export function restBuryPointUserBehaviorAppointmentCallBack({ phone }) {
  return omniAxios({
    url: config.restBuryPointUserBehaviorAppointmentCallBackPath + "/" + phone,
    method: "get",
    params: {},
    withCredentials: false,
  });
}
//发送验证码
export function restUApiMemberHomeSendSms({ phone }) {
  return omniAxios({
    url: config.restUApiMemberHomeSendSmsPath,
    method: "post",
    params: {
      phone,
    },
    isFormData: true,
    withCredentials: false,
    isTwoPointZeroInterfaceApi: true,
  });
}
//发送验证码(滑块)
export function restUApiMemberHomeSendSmsSliding({ phone }) {
  return omniAxios({
    url: config.restUApiMemberHomeSendSmsSlidingPath,
    method: "post",
    params: {
      phone,
    },
    isFormData: true,
    withCredentials: false,
    isTwoPointZeroInterfaceApi: true,
  });
}
//登录/注册
export function restCommonHomepageLoginOrRegister({ phone, code }) {
  const headers = { fingerId: Cookies.get(CookieKeys.qlmVisitorId)||'',
    regUrl: window.location.href,
    regTitle:encodeURI(document.title),};
 
  return omniAxios({
    url: config.restCommonHomepageLoginOrRegisterPath,
    method: "post",
    params: {
      company: "",
      name: "",
      zhiwu: "",
      phone,
      code,
    },
    header:headers,
    withCredentials: false,
  });
}
export function restUserApiHomepageLogout() {
  return omniAxios({
    url: config.restUserApiHomepageLogoutPath,
    method: "get",
    params: {},
  });
}

// 账号密码登录接口
export function restUApiUserNewWebLogin({ username, password }) {
  return omniAxios({
    url: config.restUApiUserNewWebLoginPath,
    method: "get",
    params: {
      username,
      psw: password,
      remLogin: 1,
      source: "",
    },
    useDevServerProxy: true,
    isTwoPointZeroInterfaceApi: true,
  });
}

// 验证码登录
export function restUApiUserPhoneLogin({ username, password }) {
  const headers = { fingerId: Cookies.get(CookieKeys.qlmVisitorId)||'',
    regUrl: window.location.href,
    regTitle:encodeURI(document.title),};
 
  return omniAxios({
    url: config.restUApiUserPhoneLoginPath,
    method: "get",
    params: {
      username,
      password,
    },
    header:{...headers},
    isTwoPointZeroInterfaceApi: true,
    withCredentials: false,
    header: { Authorization: `Basic ${password}`},
    useDevServerProxy: true,
  });
}

//获取可以手机号登录的用户类型
export function restUApiMemberHomeGetUsers({ phone, code }) {

  const headers = { fingerId: Cookies.get(CookieKeys.qlmVisitorId)||'',
    regUrl: window.location.href,
    regTitle:encodeURI(document.title),};
 
  return omniAxios({
    url: config.restUApiMemberHomeGetUsersPath,
    method: "post",
    params: {
      phone,
      code,
      fingerId: Cookies.get(CookieKeys.qlmVisitorId),
      regUrl: window.location.href,
      regTitle:document.title
    },
    header:{...headers},
    isFormData: true,
    isTwoPointZeroInterfaceApi: true,
    withCredentials: false,
  });
}

// 获取小程序二维码接口
export function restULoginQrCodeUnionIdLogin() {
  const fingerId = Cookies.get(CookieKeys.qlmVisitorId) || "";
  const headers = { logidUrl: document.location.href ,  fingerId: Cookies.get(CookieKeys.qlmVisitorId),
    regUrl: window.location.href,
    regTitle:encodeURI(document.title),};
  fingerId ? (headers.fingerId = fingerId) : "";
  return omniAxios({
    url: config.restULoginQrCodeUnionIdLoginPath,
    method: "get",
    header:headers,
    isTwoPointZeroInterfaceApi: true,
  });
}

// 小程序二维码轮询接口
export function restULoginQrCodeGetLoginQrCodeState(params) {
  return omniAxios({
    url: config.restULoginQrCodeGetLoginQrCodeStatePath,
    isTwoPointZeroInterfaceApi: true,
    method: "get",
    params,
  });
}

// 完善用户信息
export function restUPersonalMembersInfoUpdate({ dwmc, linkName, zhiwu, source }) {
  return omniAxios({
    url: config.restUPersonalMembersInfoUpdatePath,
    isTwoPointZeroInterfaceApi: true,
    isFormData: true,
    method: "post",
    params: {
      dwmc,
      linkName,
      zhiwu,
      source,
    },
  });
}
// 公共埋点
export function userBehaviorInsertRecordWebsite(params) {
  return omniAxios({
    url: config.userBehaviorInsertRecordWebsitePath,
    method: "post",
    params,
    isTracker: true, // 埋点类接口
    withCredentials: false,
  });
}
